import React, { useState, useEffect } from "react";
import "./index.css";
import { useFormik } from "formik";
import { invoiceValidationSchema } from "./InvoiceEditor.schema";
import { Input } from "./Components/CommonUI/Input/Input";
import AlertMessage from "../AlertMessage/AlertMessage";
import {
  Dropdown,
  Checkbox,
  // SubmitBtn,
  DatePicker,
  Combobox,
  invoiceFormButtons,
} from "./Components/CommonUI/index";
import { IinvoiceEditorTypes } from "./InvoiceEditor.types";
import Loader from "../Loader/Loader";
import { invoiceEditorFields } from "./InvoiceEditor.fields";
import {
  PutInvoicesService,
  UpdateInvoiceStageAndArchiveStatusService,
} from "../../Services/InvoiceService/InvoiceService";
// import { Dispatch } from "@reduxjs/toolkit";
import { reloadtabledata } from "../../Reducer/AddInvoiceReducer";
import { useDispatch, useSelector } from "react-redux";
import { useInvoiceActions } from "../../hooks/useInvoiceActions";
import { HiDocumentDuplicate } from "react-icons/hi";
import { Textarea } from "./Components/CommonUI/Textarea/Textarea";
import { useSuppliers } from "./supplierList";
import { useCategories } from "./categoryList";
import { comboboxOption } from "./constants";
import { DatePickerNew } from "./Components/CommonUI/DatePicker/DatePickerNew";
import { useLocation,useNavigate } from "react-router-dom";
import { compareDuplicateInvoiceApi } from "../../Services/DuplicateService/DuplicateApi";

const InvoiceEditor = ({
  setInvoiceView,
  invoiceData,
  nextStage,
  handleNextInvoice,
  isLastInvoice,
  onEdit,
  refreshInvoices,
}: IinvoiceEditorTypes & { onEdit?: () => void }) => {
  const {
    makeInvoiceReady,
    makeInvoiceEdited,
    makeInvoicesArchived,
    makeInvoicesUnArchived,
  } = useInvoiceActions();
  const [uploading, setUploading] = useState(false);
  // *OnSubmit function for the form
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // const suppliers = useSuppliers(); supplierOptions
  const supplierList: comboboxOption[] = useSuppliers();
  const categoryList: comboboxOption[] = useCategories(); // Custom hook to fetch categories
  const invoicefield = invoiceEditorFields(supplierList, categoryList); // Custom hook to fetch suppliers
  console.log("Suppliers in Invoice Editor:");
  console.log(supplierList);
  const location = useLocation();
  console.log("Invoice Editor");
  console.log("Invoice Editor",invoiceData);
  // const SubmitBtnClick = async (values: any) => {
  //   if (new Date(values.dueDate) < new Date(values.invoiceDate)) {)
  //     AlertMessage({
  //       type: "error",
  //       text: "Due Date cannot be earlier than Invoice Date",
  //     });
  //     return;
  //   }

  //   try {
  //     setUploading(true);

  //     makeInvoiceReady(
  //       [formik.values.invoiceId],
  //       nextStage,
  //       formik.values.archiveStatus,
  //     );

  //     AlertMessage({ type: "success", text: "Invoice Updated Successfully" });
  //   } catch (error) {
  //     console.error("Error in Invoice Editor: \n ", error);
  //   } finally {
  //     setUploading(false);
  //     if (nextStage === 21 || nextStage === 2) {
  //       dispatch(reloadtabledata(true));
  //     }

  //     AlertMessage({ type: "success", text: "Invoice Updated Successfully" });

  //     // Auto-open next invoice if not the last one, otherwise close the view
  //     if (handleNextInvoice && !isLastInvoice) {
  //       handleNextInvoice();
  //     } else {
  //       setInvoiceView(false);
  //     }
  //   }
  // };
  console.log(invoiceData);
 

  const formik = useFormik({
    initialValues: invoiceData?.[0] || {},
    enableReinitialize: true,
    //onSubmit: SubmitBtnClick,
    onSubmit: () => {},
    validationSchema: invoiceValidationSchema,
  });

  const matchOptionId = (
    name: unknown,
    list: comboboxOption[],
    current: unknown,
  ) => {
    const matched = list.find(
      (item) =>
        item.optionName?.trim().toLowerCase() ===
        String(name ?? "").trim().toLowerCase(),
    );
    if (matched?.optionId != null) return matched.optionId;
    if (current === null || current === undefined || current === "") return null;
    const parsed = Number(current);
    return Number.isFinite(parsed) ? parsed : null;
  };

  const buildSavePayload = () => {
    const values = formik.values;
    return {
      ...values,
      invoiceDate: values.invoiceDate || null,
      dueDate: values.dueDate || null,
      supplierId: matchOptionId(
        values.supplier,
        supplierList,
        values.supplierId ?? values.SupplierId,
      ),
      categoryId: matchOptionId(
        values.category,
        categoryList,
        values.categoryId ?? values.CategoryId,
      ),
    };
  };

  const handleChange = (e: any) => {
    onEdit?.();
    formik.handleChange(e);
  };

  // Save button handler - updates the invoice without changing the stage, and marks it as edited
  const handleSave = async () => {
    try {
      // setUploading(true);
      console.warn("Saving Invoice with data:", formik.values);

      const payload = {
        ...formik.values,
        invoiceDate: formik.values.invoiceDate || null,
        dueDate: formik.values.dueDate || null,
      };

      await PutInvoicesService(formik.values.stageId, payload);
      makeInvoiceEdited([formik.values.invoiceId], formik.values.stageId);

      AlertMessage({
        type: "success",
        text: "Invoice saved successfully",
      });
      // dispatch(reloadtabledata(true));
      onEdit?.();
    } catch (error) {
      console.error("Save failed:", error);
      AlertMessage({
        type: "error",
        text: "Failed to save invoice",
      });
    } finally {
      refreshInvoices();
      // setUploading(false);
      // ← removed navigation, stays on the same page
    }
  };
  const archiveStatus = "Archived";

  // Move to Archive handler - moves the invoice to archive status
  const handleMoveToArchive = async () => {
    try {
      await PutInvoicesService(
        formik.values.stageId, // or keep existing stage
        buildSavePayload(),
      );

      if (formik.values.invoiceId) {
        // upodate invoice data
        makeInvoicesArchived(
          [
            {
              invoiceId: formik.values.invoiceId,
              invoicearchieveStatus: archiveStatus,
              invoiceStageId: formik.values.stageId,
            },
          ],
          //[formik.values.invoiceId], formik.values.stageId
        );
      }
      AlertMessage({ type: "success", text: "Invoice Archive Successfully" });
      // Archive stage ID is 24
    } catch (error) {
    } finally {
      if (handleNextInvoice && !isLastInvoice) {
        handleNextInvoice();
      } else {
        refreshInvoices();
        setInvoiceView(false);
      }
    }
  };

  // Move to Ready handler - moves the invoice to 'Ready' stage (stageId 21)
  const handleMoveToReady = async () => {
    try {
      await PutInvoicesService(
        formik.values.stageId, // or keep existing stage
        formik.values,
      );

      makeInvoiceReady(
        [formik.values.invoiceId],
        formik.values.stageId,
        formik.values.archiveStatus,
      );
      AlertMessage({
        type: "success",
        text: "Invoice moved to Ready successfully",
      });
    } catch (error) {
    } finally {
      if (handleNextInvoice && !isLastInvoice) {
        handleNextInvoice();
      } else {
        refreshInvoices();
        setInvoiceView(false);
      }
    }
  };
  const handleMoveTounArchive = async () => {
    try {
      // makeInvoiceArchived(
      //   [formik.values.invoiceId],
      //   formik.values.stageId,
      //   archiveStatus,
      // );
      await PutInvoicesService(
        formik.values.stageId, // or keep existing stage
        formik.values,
      );

      /*
       selectedRows.map((row) => {
          return {
            invoiceId: row.id,
            invoicearchieveStatus: row.archiveStatus,
            invoiceStageId: row.stageId,
          };
        }
      ),
      */
      if (formik.values.invoiceId) {
        // upodate invoice data
        UpdateInvoiceStageAndArchiveStatusService(
          {
            invoiceIds: [formik.values.invoiceId],
            stageId: null,
            archiveStatus: "UnArchived",
          },

          //[formik.values.invoiceId], formik.values.stageId
        );
      }
      AlertMessage({ type: "success", text: "Invoice Archive Successfully" });
      // Archive stage ID is 24
    } catch (error) {
    } finally {
      if (handleNextInvoice && !isLastInvoice) {
        handleNextInvoice();
      } else {
        refreshInvoices();
        setInvoiceView(false);
      }
    }
  };

  // Buttons for different stages
  const buttonsForStages: Record<string, React.ReactNode[]> = {
    inbox: [
      invoiceFormButtons.save(handleSave, uploading, {}),
      invoiceFormButtons.moveToArchive(handleMoveToArchive, uploading, {}),
      invoiceFormButtons.moveToReady(handleMoveToReady, uploading, {}),
    ],

    "to-review": [
      invoiceFormButtons.save(handleSave, uploading, {}),
      invoiceFormButtons.moveToArchive(handleMoveToArchive, uploading, {}),
      invoiceFormButtons.moveToReady(handleMoveToReady, uploading, {}),
    ],

    ready: [
      invoiceFormButtons.save(handleSave, uploading, {}),
      invoiceFormButtons.moveToArchive(handleMoveToArchive, uploading, {}),
    ],
    archive: [
      invoiceFormButtons.save(handleSave, uploading, {}),
      invoiceFormButtons.moveToUnArchive(handleMoveTounArchive, uploading, {}),
    ],
  };
  //  Auto-calculate formula-based fields like netAmount
  useEffect(() => {
    invoicefield.forEach((field) => {
      if (field.formula) {
        const newValue = field.formula(formik.values);
        if (formik.values[field.name] !== newValue) {
          formik.setFieldValue(field.name, newValue);
        }
      }
    });
  }, [formik.values.totalAmount, formik.values.taxAmount]);

  // * Loader check
  if (!invoiceData || invoiceData.length === 0 || !invoiceData[0]?.invoiceId) {
    return <Loader />;
  }
  const handleRefreshInvoices = () => {
  refreshInvoices();
};

const handleCompare = async () => {
  const duplicateFlagId = invoiceData?.[0]?.duplicateFlagId;

  if (duplicateFlagId === undefined) {
    return;
  }


  try {
    const response = await compareDuplicateInvoiceApi(duplicateFlagId);
    navigate("/inbox/duplicate-invoice-compare", {
      state: {
        originalInvoice: response,
        duplicateInvoice: response,
      },
    });
  } catch (error) {
    console.error("Error fetching duplicate invoice:", error);
  }
};
  //const invoicefield = invoiceEditorFields(suppliers); // Custom hook to fetch suppliers
  return (

  <div className="invoiceEditor">
    {invoiceData?.[0]?.isDuplicate && (
  <div className="duplicate-detected">
    <div className="duplicate-detected-message">
      <span className="duplicate-icon">
        <HiDocumentDuplicate />
      </span>
      <span>Possible duplicate detected</span>
    </div>

          <button
            type="button"
            className="duplicate-compare"
             onClick={handleCompare}
          >
      Compare
    </button>
  </div>
)}

      <form onSubmit={(e) => formik.handleSubmit(e)}>
        {invoicefield.map((field) => {
          switch (field.componentType) {
            case "dropdown":
              return (
                <Dropdown
                  disabled={field.disabled}
                  name={field.name}
                  label={field.label}
                  value={formik.values[field.name]}
                  options={
                    Array.isArray(field.options)
                      ? (field.options as string[])
                      : []
                  }
                  errorMessage={
                    formik.errors[field.name] as string | string[] | ""
                  }
                  iserror={
                    !!(formik.errors[field.name] && formik.touched[field.name])
                  }
                  onChange={handleChange}
                  onBlur={formik.handleBlur}
                />
              );

            case "input":
              return (
                <Input
                  placeholder={field.placeholder}
                  disabled={field.disabled}
                  inputType={field.inputType || "text"}
                  name={field.name}
                  value={formik.values[field.name]}
                  errorMessage={
                    formik.errors[field.name] as string | string[] | ""
                  }
                  label={field.label}
                  onChange={handleChange}
                  onBlur={formik.handleBlur}
                  iserror={
                    !!(formik.errors[field.name] && formik.touched[field.name])
                  }
                />
              );

            case "textarea":
              return (
                <Textarea
                  disabled={field.disabled}
                  name={field.name}
                  label={field.label}
                  value={formik.values[field.name]}
                  placeholder={field.placeholder}
                  rows={2}
                  //errorMessage={formik.errors[field.name]}
                  iserror={
                    !!(formik.errors[field.name] && formik.touched[field.name])
                  }
                  onChange={handleChange}
                  onBlur={formik.handleBlur}
                />
              );

            case "checkbox":
              return (
                <Checkbox
                  disabled={field.disabled}
                  inputType={field.inputType || "text"}
                  name={field.name}
                  value={formik.values[field.name]}
                  errorMessage={
                    formik.errors[field.name] as string | string[] | ""
                  }
                  label={field.label}
                  onChange={handleChange}
                  onBlur={formik.handleBlur}
                  iserror={
                    !!(formik.errors[field.name] && formik.touched[field.name])
                  }
                />
              );

            case "date":
              return (
                <div>
                  <DatePickerNew
                    disabled={field.disabled}
                    inputType={field.inputType || "text"}
                    name={field.name}
                    value={formik.values[field.name]}
                    errorMessage={
                      formik.errors[field.name] as string | string[] | ""
                    }
                    label={field.label}
                    onChange={handleChange}
                    onBlur={formik.handleBlur}
                    iserror={
                      !!(
                        formik.errors[field.name] && formik.touched[field.name]
                      )
                    }
                  />
                </div>
              );

            case "combobox":
              // if (field.options?.[0]? type !== "combobox") {}
              return (
                <Combobox
                  addNewType={field.addNewType}
                  disabled={field.disabled}
                  name={field.name}
                  label={field.label}
                  value={formik.values[field.name]}
                  options={
                    field?.options?.length &&
                    typeof field.options[0] === "object"
                      ? (field.options as comboboxOption[])
                      : []
                    // : (field.options as comboboxOption[]) || [{} as comboboxOption]
                  }
                  errorMessage={
                    formik.errors[field.name] as string | string[] | ""
                  }
                  iserror={
                    !!(formik.errors[field.name] && formik.touched[field.name])
                  }
                  onChange={(val: string, option: comboboxOption | null) => {
                    onEdit?.();
                    formik.setFieldValue(field.name, val,true);
                    formik.setFieldValue(
                      "supplierId",
                      option?.optionId || null,
                      false,
                    );
                  }}
                  onBlur={formik.handleBlur}
                  allowAddNew={field.allowAddNew}
                />
              );
          }
        })}

        {/* buttonsWrapper Collections */}
      </form>
      <div className="invoiceEditor-buttons">
        {buttonsForStages[location.pathname.split("/")[1]]}
        {/* {invoiceFormButtons.save(handleSave, uploading, {})}
        {invoiceFormButtons.moveToArchive(handleMoveToArchive, uploading, {})}
        {invoiceFormButtons.moveToReady(handleMoveToReady, uploading, {})} */}
      </div>
    </div>
  );
};

export default InvoiceEditor;
